import React from 'react';
import { Text, View } from 'react-native';
import MyAppText from '../../components/MyAppText';
import { translate } from '../../services/translate';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { WindowInformation } from '../../services/window-information';

const bodyItems: { name: string; value: number; }[] = [
    {
        name: 'low_masculine',
        value: 0.63,
    },
    {
        name: 'normal',
        value: 0.714,
    },
    {
        name: 'high_masculine',
        value: 0.77,
    }
];

export default function ThresholdDetailTooltip() {
    const { styles, theme } = useStyles(stylesheet);
    const windowInfo = WindowInformation();

    return (
        <View style={styles.tooltipContainer(windowInfo.isMobile)}>
            <MyAppText style={styles.tooltipTitle}>{translate('confidenceLimit')}</MyAppText>
            <MyAppText style={styles.tooltipSubTitle}>{translate('thresholdDetail')}</MyAppText>

            <View>
                <MyAppText style={styles.bodyTitle}>{translate('recommendedValues')}:</MyAppText>
                <View>
                    {bodyItems?.map((item, i) => (
                        <View key={i}>
                            <View style={{ flexDirection: 'row', gap: 8, alignItems: 'flex-start' }}>
                                <View style={{ width: 5, height: 5, marginTop: 8, borderRadius: 9999, backgroundColor: theme.colors.neutral['400'] }} />
                                <MyAppText style={{ color: theme.colors.neutral['400'] }}>
                                    <Text style={styles.itemName}>
                                        {translate(item.name)}:
                                    </Text>
                                    <Text style={styles.itemDescription}>
                                        {item.value}
                                    </Text>
                                </MyAppText>
                            </View>
                        </View>
                    ))}
                </View>
            </View>
            <MyAppText style={styles.tooltipSubTitle}>{translate('thresholdDetail2')}</MyAppText>
        </View>
    );
}

const stylesheet = createStyleSheet(theme => ({
    tooltipContainer: (isMobile: boolean) => ({
        flexDirection: 'column',
        rowGap: 12,
        backgroundColor: theme.colors.card.background,
        padding: 12,
        zIndex: 9999,
        borderRadius: 8,
        borderTopLeftRadius: isMobile ? 8 : 0,
        shadowColor: '#000',
        shadowOpacity: 0.45,
        shadowOffset: {
            height: -2,
            width: 2
        },
        shadowRadius: 10,
    }),
    tooltipTitle: {
        fontWeight: '700',
        fontSize: 14,
        color: theme.colors.neutral['500']
    },
    tooltipSubTitle: {
        fontWeight: '500',
        fontSize: 12,
        color: theme.colors.neutral['400']
    },
    bodyTitle: {
        fontWeight: '700',
        fontSize: 12,
        color: theme.colors.neutral['400']
    },
    itemName: {
        fontWeight: '700',
        fontSize: 12,
        marginRight: 4,
    },
    itemDescription: {
        fontWeight: '500',
        fontSize: 12,
    },
}));
